<template>
  <!-- 数据管理 - 企业人材机数据库 author: zhangxiaofeng-->
  <div class="upload-excel" @click="pageHandle">
    <div class="excel-title">
      导入Excel文件
      <i class="w-icon-guanbi close-btn" @click="goBack"></i>
    </div>
    <div class="excel-content">
      <div class>
        <div class="select-excel">
          <table class width="100%" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td width="5px"></td>
                <td width="70px" class="align-right">
                  <font class="color-red">*&nbsp;</font>导入地区：
                </td>
                <td width="120px">
                  <w-select size="small" class="width-95" v-model="areaSelected" name="地区选择" @change="areaSelect">
                    <w-option
                      v-for="(val, i) in areaOptions"
                      :key="i"
                      :value="val"
                      :label="val"
                    ></w-option>
                  </w-select>
                  <span class="color-red" v-if="showError&&areaSelected=='请选择地区'">请选择地区</span>
                  <span class="align-right" style="margin-left: 20px;" v-if="areaSelected=='安徽'">
                    <font class="color-red">*&nbsp;</font>计税方式：
                    <select class="width-150" name="计税方式选择" @change="taxSelect">
                      <option :selected="taxSelected==''" value>请选择计税方式</option>
                      <option :selected="taxSelected=='4'" value="4">增值税(简易计税方法)</option>
                      <option :selected="taxSelected=='5'" value="5">增值税(一般计税方法)</option>
                    </select>
                  </span>
                  <span class="color-red" v-if="areaSelected=='安徽'&&taxSelected==''">请选择计税方式</span>
                </td>
                <td width="100px"></td>
                <td class="action-tech color-red">操作技巧：</td>
              </tr>
              <tr>
                <td width="5px"></td>
                <td width="70px" class="align-right">Excel表：</td>
                <td width="540px">
                  <w-input size="small" :value="excelName" type="text" disabled="disabled" class="width-400 margin-right-10" />
                  <w-button size="small" type="primary" @click="selectFile('file')">
                    选择
                    <input
                      ref="file"
                      @change="uploadExcel"
                      type="file"
                      name="file"
                      style="opacity: 0;filter: alpha(opacity = 0);display: none;"
                      accept
                    />
                  </w-button>
                  <!--<a class="ui-btn ui-btn_green text-align-center" @click="selectFile('file')">-->
                    <!--选择-->
                    <!--<input-->
                      <!--ref="file"-->
                      <!--@change="uploadExcel"-->
                      <!--type="file"-->
                      <!--name="file"-->
                      <!--style="opacity: 0;filter: alpha(opacity = 0);display: none;"-->
                      <!--accept-->
                    <!--/>-->
                  <!--</a>-->
                  <!--<a class="ui-btn ui-btn_green" style="position: relative;">-->
                  <!--<div>选择</div>-->
                  <!--<div class="input-box">-->
                  <!--<input ref='file' @change="uploadExcel" type="file" name="file" class="upload-input input-box" accept />-->
                  <!--<label-->
                  <!--style="opacity: 0; width: 100%; height: 100%; display: block; cursor: pointer; background: rgb(255, 255, 255);"-->
                  <!--&gt;</label>-->
                  <!--</div>-->
                  <!--</a>-->
                </td>
                <td width="100px"></td>
                <td class="action-tech1 color-red">1. 智能识别不理想时，请手动识别列，再点击[识别行]按钮</td>
              </tr>
              <tr>
                <td width="5px"></td>
                <td width="70px" class="align-right">数据表：</td>
                <td>
                  <w-select
                    v-model="sheetSelected"
                    size="small"
                    class="ui-select width-530"
                    id="excelSelectSheetName"
                    @change="sheetSelect"
                  >
                    <w-option
                      v-for="(val, i) in sheetOptions"
                      :key="i"
                      :value="val"
                      :label="val"
                    ></w-option>
                  </w-select>
                </td>
                <td width="100px"></td>
                <td class="action-tech2 color-red">
                  2. 可以通过shift+左键方式在 [序号]列对行进行批量选择，
                  <br />&nbsp;&nbsp;&nbsp;选择后右键进行选择、取消、识别等操作
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="ui-mt10 ui-mb10">
          <w-button type="minor" @click="identifeWorkRow">识别行</w-button>
          <w-button type="minor" @click="chooseAll">全部选择</w-button>
          <w-button type="minor" @click="chooseZero">全部取消</w-button>
          <!--<a class="ui-btn" @click="identifeWorkRow">识别行</a>-->
          <!--<a class="ui-btn" @click="chooseAll">全部选择</a>-->
          <!--<a class="ui-btn" @click="chooseZero">全部取消</a>-->
          <span class="errorExcelFile" v-if="excleError">此excel文件格式损坏，请使用其它文件！</span>
          <span class="errorExcelFile" v-if="sendError">无有效数据可用于导入</span>
        </p>
        <div class="excel-box">
          <div class="dataTables_wrapper no-footer">
            <div class="dataTables_scroll">
              <div
                class="dataTables_scrollHead"
                style="overflow: hidden; position: relative; border: 0px; width: 100%;"
              >
                <div
                  class="dataTables_scrollHeadInner"
                  :style="{boxSizing: 'content-box', paddingRight: overheight?'17px':'0px'}"
                >
                  <table
                    class="display dataTable no-footer workListTable_wrapper"
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    style="margin-left: 0px;"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          :style="{width:columns[i]+'px'}"
                          rowspan="1"
                          colspan="1"
                          v-for="(val, i) in headdata[sheetSelected]"
                          :key="sheetSelected+time+i"
                        >
                          <template v-if="val.selected">
                            <select v-model="val.selected" @change="thSelect($event, i)">
                              <option
                                v-for="(opt, k) in val.children"
                                :key="k"
                                :selected="opt.value == val.selected"
                                :value="opt.value"
                              >{{opt.lable}}</option>
                            </select>
                          </template>
                          <template v-else>{{val}}</template>
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
              <div
                class="dataTables_scrollBody"
                :style="{height:tableHeight+'px'}"
                ref="scrollBody"
              >
                <table
                  class="display dataTable no-footer workListTable"
                  cellspacing="0"
                  width="100%"
                  role="grid"
                  aria-describedby="workListTable_info"
                  style="width: 100%;"
                >
                  <thead>
                    <tr role="row" style="height: 0px;">
                      <th
                        :style="{width:columns[i]+'px'}"
                        style="padding-top: 0px; padding-bottom: 0px; border-top-width: 0px; border-bottom-width: 0px; height: 0px;"
                        rowspan="1"
                        colspan="1"
                        v-for="(val, i) in headdata[sheetSelected]"
                        :key="i"
                      ></th>
                    </tr>
                  </thead>

                  <tbody onselectstart="return false;" @click.exact.prevent.right="rightHandle">
                    <tr
                      :ref="'tr'+trindex"
                      role="row"
                      v-for="(trdata, trindex) in bodydata[sheetSelected]"
                      :key="sheetSelected+time+trindex"
                    >
                      <template v-for="(tddata, tdindex) in trdata">
                        <td
                          :key="tdindex"
                          v-if="tdindex<headdata[sheetSelected].length && trindex>1 && tdindex==1"
                          @click.exact="clickHandle(trindex, tdindex)"
                          @click.ctrl="ctrlHandle(trindex, tdindex)"
                          @click.shift="shiftHandle(trindex, tdindex)"
                          :class="{'active':bgtds.indexOf(trindex+'-'+tdindex)>-1}"
                        >
                          <input
                            :ref="'checkbox'+trindex"
                            @click.self="'javascript: void(0);'"
                            type="checkbox"
                            name="tdcheckbox"
                          />
                        </td>
                        <td
                          :key="tdindex"
                          v-else-if="tdindex<headdata[sheetSelected].length"
                          @click.exact="clickHandle(trindex, tdindex)"
                          @click.ctrl="ctrlHandle(trindex, tdindex)"
                          @click.shift="shiftHandle(trindex, tdindex)"
                          :class="{'active':bgtds.indexOf(trindex+'-'+tdindex)>-1}"
                          v-html="tddata"
                        ></td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="dataTables_info">
              当前显示 1 到 {{bodydata&&bodydata[sheetSelected]? bodydata[sheetSelected].length:'0'}} 条，共 {{bodydata&&bodydata[sheetSelected]? bodydata[sheetSelected].length:'0'}} 条记录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                v-if="bgtds.length"
              >{{bgtds.length}} cell{{bgtds.length>1?'s':''}} 选择</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-foot">
      <!--<input class="ui-btn ui-btn_blue" type="button" value="导入" @click="sendData" />-->
      <!--<input class="ui-btn" id="refreshImportExcelTable3" type="button" value="取消" @click="goBack" />-->
      <w-button type="primary" @click="sendData">导入</w-button>
      <w-button type="minor" @click="goBack(true)">取消</w-button>
    </div>
    <div
      class="right-menu"
      :style="{display: rightM?'none':'block', left:left+'px', top: top+'px'}"
    >
      <ul>
        <li
          :class="['right-item',val=='选择'?'top-border':'']"
          v-for="(val, index) in rightBtn"
          :key="index"
          @click="rightMHandle(val)"
        >{{val}}</li>
      </ul>
    </div>
    <w-dialog @close="show=!show" :show="show" footer-style="padding-bottom: 24px;border-top: 0;">
      <span class="w__dialog--title" slot="header">导入结果</span>
      <p>{{show}}</p>
      <div slot="footer">
        <w-button type="primary" @click="showDetail" v-if="detail">查看详情</w-button>
        <w-button type="minor" @click="show=!show">继续导入</w-button>
        <w-button type="minor" @click="goBack">结束导入</w-button>
        <!--<input-->
          <!--class="ui-btn ui-btn_blue"-->
          <!--type="button"-->
          <!--value="查看详情"-->
          <!--v-if="detail"-->
          <!--@click="showDetail"-->
        <!--/>-->
        <!--<input class="ui-btn" type="button" value="继续导入" @click="show=!show" />-->
        <!--<input class="ui-btn" type="button" value="结束导入" @click="goBack" />-->
      </div>
    </w-dialog>
  </div>
</template>
<script>
import windowResizeMixin from '@/assets/mixins/window-resize'
import MaterialService from '@/assets/service/material'
import { mapState } from 'vuex'
const compiler = require('vue-template-compiler')
export default {
  name: 'MaterialUpload',
  data () {
    return {
      columns: [
        10,
        10,
        32.5,
        10,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38,
        38
      ],
      areaOptions: [
        '请选择地区',
        '北京',
        '江苏',
        '广东',
        '深圳',
        '河南',
        '黑龙江',
        '陕西',
        '河北',
        '福建',
        '甘肃',
        '广西',
        '贵州',
        '海南',
        '湖北',
        '湖南',
        '吉林',
        '江西',
        '辽宁',
        '内蒙古',
        '宁夏',
        '青海',
        '山东',
        '山西',
        '安徽',
        '四川',
        '天津',
        '西藏',
        '新疆',
        '云南',
        '重庆',
        '上海'
      ],
      areaSelected: '请选择地区',
      sheetOptions: [],
      sheetSelected: '',
      excelName: '',
      taxSelected: '',
      headdata: { '': ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'] },
      bodydata: {
        '': [
          [
            '1',
            '',
            '无效行',
            '1',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P'
          ]
        ]
      },
      rightBtn: [
        '无效行',
        '人工',
        '材料',
        '机械',
        '主材',
        '设备',
        '选择',
        '取消'
      ],
      bgtds: [],
      overheight: true,
      tableHeight: 0,
      file: [],
      rightM: true,
      left: 0,
      top: 0,
      time: 0,
      excleError: false,
      sendError: false,
      show: false,
      detail: false,
      persent: 0,
      showError: false
    }
  },
  computed: {
    ...mapState({
      userType: state => state.user.user.userType
    }),
    spaceType () {
      let type = ''
      switch (+this.userInStore.userType) {
        case 1:
          type = 'share'
          break
        case 2:
          type = 'self'
          break
        case 3:
          type = 'staff'
          break
        default:
      }
      return type
    }
  },
  mixins: [windowResizeMixin],
  methods: {
    // 点击上传按钮，触发文件选择弹窗
    selectFile (file) {
      this.$refs[file].click()
    },
    // 查看导入详情
    showDetail () {
      console.log('详情')
      var win = window.open()
      // 流使用结束后 必须要关闭
      let htmlStr = ''
      this.detail.map(item => {
        htmlStr += `<tr>
          <td>${item.code}</td>
          <td>${item.name}</td>
          <td>${item.spec}</td>
          <td>${item.result}</td>
        </tr>`
      })
      win.document.write(`<head>
      <title>导入详情</title>
      <meta http-equiv="Content-Type" content="text/html;charset=utf-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge, chrome=1">
      <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
      <style>
        *{margin:0;padding: 0;}
          .info{
            width: 1000px;
            margin: 20px auto;
          }
          table{
            border: 1px solid #ccc;
            border-collapse: collapse;
            border-spacing: 0;
            font-size: 14px;
          }
          caption{
            padding:8px 5px;
            border: 1px solid #ccc;
            border-bottom: none;
            text-align: left;
            font-size: 20px;
          }
          caption a{
            color: #1C6CCD;
            text-decoration: none;
            float: right;
          }
          tr{
            height: 30px;
          }
          tr:hover td{
            background-color: #E6F9FF;
          }
          th,
          td{
            padding:8px 5px;
            border: 1px solid #ccc;
            text-align: left;
          }
          th{
            background-color: #EEE;
            color: #666;
          }
        </style>
      </head>
      <body>
      <div class="info" id="___info">
        <table width="100%" cellspacing="0" cellpadding="0">
          <caption>人材机导入详情<a href="javascript:window.print()">打印</a></caption>
          <thead>
            <tr>
              <th width="200">编码</th>
              <th>名称</th>
              <th>规格型号</th>
              <th>未导入原因</th>
            </tr>
          </thead>
          <tbody>
            ${htmlStr}
          </tbody>
        </table>
      </div>
      <body></head>`)
      win.document.close()
    },
    // 识别行
    identifeWorkRow () {
      // 1 获取excel的所有数据
      let allData = this.bodydata[this.sheetSelected]

      for (let i in allData) {
        if (!isNaN(i) && i > 1) {
          let trEL = this.$refs['tr' + i][0]

          // textbox和标识select index 相差1
          let selectEl = trEL.cells[2].childNodes[0]
          var _cellselect = selectEl.options[selectEl.selectedIndex].value

          if (_cellselect == null || _cellselect === undefined) {
            continue
          }

          // 查看名称和编码
          var name = null
          var code = null
          for (var k in this.headdata[this.sheetSelected]) {
            if (k > 3) {
              var cloumnValue = this.headdata[this.sheetSelected][k].selected
              // 不是未识别 则增加到obj中
              var value = allData[i][k]
              if (value === '' || value === undefined || value == null) {
                continue
              }

              if (cloumnValue === 'Code') {
                code = value
              } else if (cloumnValue === 'Description') {
                name = value
              }
            }
          }

          // 如果有名称和编码 识别为主材
          if (name != null && code != null) {
            trEL.cells[1].childNodes[0].checked = true;
            [...selectEl.options].map((item, index) => {
              if (item.text === '主材') {
                selectEl.selectedIndex = index
              }
            })
          } else {
            trEL.cells[1].childNodes[0].checked = false;
            [...selectEl.options].map((item, index) => {
              if (item.text === '无效行') {
                selectEl.selectedIndex = index
              }
            })
          }
        }
      }
    },
    // 全不选
    chooseZero () {
      this.bodydata[this.sheetSelected].map((item, i) => {
        if (i > 1) {
          let tdCheckEL = this.$refs['tr' + i][0].cells[1].childNodes[0]
          tdCheckEL.checked = false
        }
      })
    },
    // 全选
    chooseAll () {
      this.bodydata[this.sheetSelected].map((item, i) => {
        if (i > 1) {
          let tdCheckEL = this.$refs['tr' + i][0].cells[1].childNodes[0]
          tdCheckEL.checked = true
        }
      })
    },
    // 更新状态
    initState () {
      this.bgtds = []
      this.overheight = true
      this.excleError = false
      this.sendError = false
    },
    // 右键选中
    rightMHandle (val) {
      let arr = []
      this.bgtds.map(i => {
        arr.push(i.split('-')[0])
      })
      arr = [...new Set(arr)]
      arr.map(i => {
        if (val === '选择') {
          this.$refs['checkbox' + i][0].checked = true
        } else if (val === '取消') {
          this.$refs['checkbox' + i][0].checked = false
        } else {
          let tdSelectEL = this.$refs['tr' + i][0].cells[2].childNodes[0]
          if (tdSelectEL.selectedOptions[0].innerText !== val) {
            [...tdSelectEL.options].map((item, index) => {
              if (item.text === val) {
                tdSelectEL.selectedIndex = index
              }
            })
          }
        }
      })
    },
    // 右键显示菜单
    pageHandle () {
      this.rightM = true
    },
    // 单元格选取
    clickHandle (tr, td) {
      let index = this.bgtds.indexOf(tr + '-' + td)
      if (index > -1 && this.bgtds.length === 1) {
        this.bgtds = [tr + '-' + td]
        this.savetdtr = undefined
      } else {
        this.bgtds = []
        this.savetdtr = [tr, td]
      }
      this.setBg(tr, td)
    },
    rightHandle ($event) {
      this.rightM = false
      this.left = $event.pageX
      this.top = $event.pageY
    },
    ctrlHandle (tr, td) {
      this.setBg(tr, td)
      this.savetdtr = [tr, td]
    },
    shiftHandle (tr, td) {
      let arr = []
      if (this.savetdtr) {
        this.shift = this.savetdtr
        let step1 = Math.abs(this.shift[0] - tr)
        let min1 = (-step1 + tr + this.shift[0]) / 2
        let step2 = Math.abs(this.shift[1] - td)
        let min2 = (-step2 + td + this.shift[1]) / 2
        for (let i = 0; i <= step1; i++) {
          for (let j = 0; j <= step2; j++) {
            arr.push(min1 + i + '-' + (min2 + j))
          }
        }
      }
      this.bgtds = arr
    },
    // 取消、选中样式
    setBg (r, c) {
      let index = this.bgtds.indexOf(r + '-' + c)
      if (index > -1) {
        this.bgtds.splice(index, 1)
      } else {
        this.bgtds.push(r + '-' + c)
      }
    },
    // 更改地区
    // areaSelect($e) {
    //   // 如果值发生改变，可显示地区未选提示
    //   if (this.areaSelected !== $e.target.value) {
    //     this.showError = true
    //   }
    //   this.areaSelected = $e.target.value
    //   if (
    //     this.areaSelected === '请选择地区' ||
    //     (this.areaSelected === '安徽' && this.taxSelected === '')
    //   ) {
    //   } else if (this.excelName !== '') {
    //     this.sendExcel()
    //   }
    // },
    areaSelect (value) {
      // 如果值发生改变，可显示地区未选提示
      // if (this.areaSelected !== $e.target.value) {
      //   this.showError = true
      // }
      // this.areaSelected = $e.target.value
      if (
        value === '请选择地区' ||
        (value === '安徽' && this.taxSelected === '')
      ) {
      } else if (this.excelName !== '') {
        this.sendExcel()
      }
    },
    // 更改计税方式
    taxSelect ($e) {
      this.taxSelected = $e.target.value
      if ($e.target.value !== '' && this.excelName !== '') {
        this.sendExcel()
      }
    },
    // 更换sheet表格
    sheetSelect ($e) {
      this.sheetSelected = $e.target.value
    },
    // 更改表头下拉框
    thSelect ($event, i) {
      let value = $event.target.value
      if (value === 'unrecognized_col') {
        return
      }
      this.headdata[this.sheetSelected].map((th, index) => {
        if (index !== i && th.selected === value) {
          th.selected = 'unrecognized_col'
        }
      })
    },
    // 设置表格高度
    setTableHeight (otherHeight) {
      const height = otherHeight + 50 || 50 // 表格默认会占用比自己 多 49px 高度
      let windowHeight = document.documentElement.clientHeight
      if (this.bodydata[this.sheetSelected].length > 1) {
        this.tableHeight = windowHeight - height
      } else {
        this.tableHeight = 160
      }
    },
    // 导入人材机数据
    sendExcelData () {
      this.excleError = false
      this.sendError = false
      if (
        this.areaSelected === '请选择地区' ||
        (this.areaSelected === '安徽' && this.taxSelected === '')
      ) {
        return
      }
      let query = {
        region: this.areaSelected,
        userType: this.userType
      }
      let param = {}
      this.bodydata[this.sheetSelected].map((column, index) => {
        if (index > 1 && this.$refs['checkbox' + index][0].checked) {
          let trEL = this.$refs['tr' + index][0]
          let selectEl = trEL.cells[2].childNodes[0]
          var _cellselect = selectEl.options[selectEl.selectedIndex].value
          if (selectEl.options[selectEl.selectedIndex].text !== '无效行') {
            let data = {
              ResCatalogID_GUID: _cellselect
            }
            this.headdata[this.sheetSelected].map((col, index) => {
              if (index > 3) {
                data[col.selected] = column[index]
              }
            })
            if (this.areaSelected === '安徽') {
              data.TaxMethod = this.taxSelected
            }
            param[index] = data
          }
        }
      })
      if (JSON.stringify(param) === '{}') {
        this.sendError = true
        return
      }
      const cacheKey = new Date().getTime()
      param = encodeURIComponent(JSON.stringify(param))

      let taskComplete = false
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (result.code === 200) {
            setTimeout(() => {
              this.show = `人材机总条数 ${result.data.allCount} ，导入 ${result.data.importedCount}  条，未导入 ${result.data.unImportedCount} 条`
              this.detail = false
              if (result.data.unImportedCount) {
                this.detail = result.data.items
              }
            }, 300)
          } else {
            this.$message.error('导入失败！')
          }
        }
      }
      // , spaceType: sessionStorage.getItem('databaseSpaceType') || 1
      MaterialService.sendExcelData(
        param,
        Object.assign(query, { cacheKey })
      ).then(res => {
        result = res
        afterTask()
      })
      this.getProgress('import', '', cacheKey).then(() => {
        taskComplete = true
        afterTask()
      })
    },
    // 发送数据
    sendData () {
      this.sendExcelData()
    },
    // 取消
    goBack () {
      this.$router.go(-1)
    },
    // 获取地区
    getArea () {
      MaterialService.getArea().then(res => {
        if (+res.code === 200 && res.data) {
          this.areaSelected = res.data
        }
      })
    },
    // 发送Excel数据
    sendExcel () {
      let file = this.$refs.file
      let area = this.areaSelected
      let formData = new FormData()
      formData.append('file', file.files[0])
      this.initState()
      MaterialService.postExcel(formData, encodeURIComponent(area)).then(
        res => {
          if (+res.code === 200 && res.data) {
            this.time = new Date().getTime()
            this.sheetSelected = res.data.sheetName[0]
            this.sheetOptions = res.data.sheetName
            this.bodydata = res.data.excelTableData
            // 有数据时设置table高度
            let otherHeight = 350
            this.setTableHeight(otherHeight)

            let headerToData = {}
            res.data.sheetName.map((name, index) => {
              headerToData[name] = res.data.excelSheetColumns[name].map(
                (th, i) => {
                  if (th.indexOf('<select') > -1) {
                    let thData = {}
                    let thAllData = compiler.compile(th)
                    thData.children = thAllData.ast.children.map(
                      (option, optionIdex) => {
                        if (option.attrsMap.selected) {
                          thData.selected = option.attrsMap.value
                        }
                        return {
                          lable: option.children[0].text,
                          value: option.attrsMap.value
                        }
                      }
                    )
                    return thData
                  } else {
                    return th
                  }
                }
              )
            })
            this.headdata = headerToData
            this.$forceUpdate()
            this.$nextTick(() => {
              this.overheight =
                this.$refs.scrollBody.scrollHeight >
                this.$refs.scrollBody.clientHeight
              this.chooseAll()
            })
          } else {
            this.headdata = {
              '': ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']
            }
            this.bodydata = {
              '': [
                [
                  '1',
                  '',
                  '无效行',
                  '1',
                  'A',
                  'B',
                  'C',
                  'D',
                  'E',
                  'F',
                  'G',
                  'H',
                  'I',
                  'J',
                  'K',
                  'L',
                  'M',
                  'N',
                  'O',
                  'P'
                ]
              ]
            }
            this.excleError = true
          }
        }
      )
    },
    // 获取Excel文件流
    uploadExcel (e, q) {
      let fileType = this.$refs.file.files[0].name.substring(
        this.$refs.file.files[0].name.lastIndexOf('.'),
        this.$refs.file.files[0].name.length
      )
      if (fileType !== '.xls' && fileType !== '.xlsx' && fileType !== '.XLS' && fileType !== '.XLSX') {
        this.$message.info('不支持此格式文件导入,请选择正确的文件')
        return
      }

      // 如果已存入Excel表格数据，可显示地区未选提示
      this.showError = true
      this.excelName = this.$refs.file.files[0].name
      if (
        this.areaSelected === '请选择地区' ||
        (this.areaSelected === '安徽' && this.taxSelected === '')
      ) {
        return false
      } else {
        this.sendExcel()
      }
    }
  },
  mounted () {
    let otherHeight = 350
    let _self = this
    this.setTableHeight(otherHeight)
    if (
      _self.$refs.scrollBody.scrollHeight > _self.$refs.scrollBody.clientHeight
    ) {
      _self.overheight = true
    } else {
      _self.overheight = false
    }
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.setTableHeight(otherHeight)
      if (
        _self.$refs.scrollBody.scrollHeight >
        _self.$refs.scrollBody.clientHeight
      ) {
        _self.overheight = true
      } else {
        _self.overheight = false
      }
    })
    this.getArea()
  }
}
</script>
<style lang="less" type="text/less">
.upload-excel {
  position: relative;
  height: 100%;
  select {
    padding: 5px 3px !important;
  }
  .excel-title {
    color: #666;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    position: relative;
    font-size: 18px;
    padding: 10px 20px;
    line-height: 24px;
  }
  .close-btn {
    float: right;
    cursor: pointer;
    color: #ccc;
  }
  .color-red {
    color: red;
  }
  .width-95 {
    width: 95px;
  }
  .width-150 {
    width: 150px;
  }
  .width-400 {
    width: 400px;
  }
  .width-530 {
    width: 468px;
  }
  .ui-mt10 {
    margin-top: 10px;
  }
  .ui-mb10 {
    margin-bottom: 10px;
  }
  .excel-content {
    padding: 10px 20px;
    min-height: 480px;
    /*min-width: 1110px;*/
  }
  .errorExcelFile {
    text-align: right;
    margin-left: 100px;
    color: red;
    font-size: 16px;
  }
  .dialog-foot {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 17px 20px;
    text-align: right;
  }
  .select-excel {
    padding: 12px 0;
    border: 1px solid #ccc;
    font-size: 12px;
    td {
      padding: 3px 0 !important;
    }
    .align-right {
      text-align: right;
    }
    input,
    select {
      border: 1px solid #ccc;
      height: 30px;
      line-height: 28px;
      background-color: #fff;
      font-size: 12px;
      color: #666;
      padding: 0 5px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
    .ui-btn_green {
      background: linear-gradient(top, #8fcf00, #6b9c00);
      background-color: #7db500;
      border-color: #5a8200;
      color: #fff !important;
      text-shadow: 1px 1px 0 #5b8400;
      &:hover {
        color: #fff !important;
        background-color: #8fcf00;
        background: linear-gradient(top, #9de400, #73a700);
      }
    }
    .action-tech {
      font-size: 14px;
    }
    .action-tech1 {
      font-size: 14px;
      margin-top: -5px;
      position: absolute;
    }
    .action-tech2 {
      font-size: 14px;
      margin-top: -24px;
      position: absolute;
      line-height: 20px;
    }
  }
  .dataTables_scrollBody {
    min-height: 160px;
    position: relative;
    overflow: auto;
    width: 100%;
    border-bottom: 1px solid #111;
  }
  .workListTable,
  .workListTable_wrapper {
    margin: 0 auto;
    clear: both;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    word-break: break-all;
    th {
      font-weight: bold;
      color: #1c6ccd;
      font-size: 12px;
      text-align: left;
      border: 1px solid #ccc;
      padding: 0 5px;
      box-sizing: content-box;
      height: 30px;
      select {
        width: 100%;
        border: none;
        padding-left: 0;
        padding-right: 0;
        outline: 0;
        text-transform: none;
      }
    }
    td {
      border: 1px solid #ccc;
      padding: 0 5px;
      text-align: left;
      box-sizing: content-box;
      height: 30px;
      font-size: 14px;
      color: #333;
      select {
        width: 100%;
        border: none;
        padding-left: 0;
        padding-right: 0;
        outline: 0;
        text-transform: none;
        color: #666;
      }
    }
  }
  .workListTable {
    tr:nth-child(odd) {
      background-color: #f9f9f9;
    }
    tr:hover {
      background-color: #f6f6f6;
    }
    td.active {
      background-color: #a6b4cd;
    }
    tbody tr:first-child {
      td {
        border-top: 0;
      }
    }
  }
  .input-box {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 80px;
    height: 28px;
    overflow: hidden;
    bottom: auto;
    right: auto;
    opacity: 0;
  }
  .dataTables_info {
    clear: both;
    float: left;
    padding-top: 0.755em;
    font-size: 14px;
  }
  .right-menu {
    display: none;
    width: 130px;
    position: absolute;
    padding: 2px;
    height: 200px;
    border: 1px solid #b8cbcb;
    background-color: #fff;
    box-shadow: 2px 2px 5px #666;
  }
  .right-item {
    display: block;
    height: 25px;
    line-height: 24px;
    padding: 0 5px 0 20px;
    font-size: 12px;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      background-color: #348ccc;
      color: #fff;
    }
  }
  .top-border {
    border-top: 1px solid #b8cbcb;
  }
  .w__dialog--box {
    width: 380px;
  }
}
</style>

